export default __webpack_public_path__ + "static/media/22.0d3d94d0.jpg";